import React, {useEffect,useState} from "react";
import Sidebar from "../../../Components/Sidebar";
import AddMembersForm from "../../../Components/AddMembersForm";
//import MembersTable from "../../../Components/MembersTable";
import BoardofStudiesTable from "../../../Components/BoardofStudiesTable"
import CqaStaffTable from "../../../Components/CqaStaffTable";
import { addStudiesMember,fetchStudiesMembers,deleteStudiesMemberById, updateStudiesMember } from "../../../redux/actions/aboutUsActions";
import { fetchCqaStaffData } from "../../../redux/actions/CQAAction";
import { useDispatch, useSelector } from "react-redux";
import PageComponent from "../../../Components/PageComponent";

function Studies() {

  const dispatch = useDispatch();
    const [deletePopup, setDeletePopup] = useState({ isOpen: false, data: null });

    const { data: studiesMemberData = [], loading } = useSelector(
      (state) => state.aboutUs.studiesMember
    );

    const { data: cqaStaffData = [], loading: cqaStaffLoading } = useSelector(
      (state) => state.CQA.cqaStaff || { data: [] }
    );

    useEffect(() => {
      dispatch(fetchStudiesMembers());
      dispatch(fetchCqaStaffData());
    }, [dispatch]);
  
    const handleDeleteConfirm = async () => {
      if (deletePopup.data) {
        await dispatch(deleteStudiesMemberById(deletePopup.data.id));
        setDeletePopup({ isOpen: false, data: null });
        dispatch(fetchStudiesMembers());
      }
    };
  
    const closeDeletePopup = () => {
      setDeletePopup({ isOpen: false, data: null });
    };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      {/* Sidebar */}
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      {/* Content Section */}
      <div className="flex-1 p-6 ml-64">
        {/* Breadcrumb */}
        <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
          <span>About Us</span>
          <span>/</span>
          <span className="text-black">Board of Studies</span>
        </div>

        {/* Forms */}
    
        <AddMembersForm title="Add Member " addMemberAction={addStudiesMember} fetchMembersAction={fetchStudiesMembers} />
        <BoardofStudiesTable
        title="Already added  Member " 
        editTitle = "Edit Member "
        MemberData={studiesMemberData}
        handleDeleteConfirm={handleDeleteConfirm}
        deletePopup={deletePopup}
        setDeletePopup={setDeletePopup}
        closeDeletePopup={closeDeletePopup}
        loading={loading}
        fetchMembers={fetchStudiesMembers}
        updateMember={updateStudiesMember} />

        <CqaStaffTable
          title="CQA Staff List"
          MemberData={cqaStaffData}
          loading={cqaStaffLoading}
        />
        {/* <DisplayMessage /> */}
      </div>
    </div>
    </PageComponent></>
  );
}

export default Studies;
